
import { mapState } from "vuex";

export default {
  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    label: { type: String, default: "" },
    metaColors: { type: Object, default: () => {} },
    instoreColorsText: { type: String, default: "" },
  },

  data() {
    return { internalSelectedTile: this.selectedTile };
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    handleClick(targetVariantId, tileLabel) {
      this.internalSelectedTile = tileLabel;
      this.$emit("select-variant-id", targetVariantId);
    },
  },
};
